import {combineReducers} from 'redux';
import {connectRouter} from 'connected-react-router'
import Settings from './Settings';
import Auth from './Auth';
import Activity from './Activity';
import Referee from './Referee';
import Submission from './Submission';

export default (history) => combineReducers({
  router: connectRouter(history),
  settings: Settings,
  auth: Auth,
  activity : Activity,
  referee: Referee,
  submission: Submission
});
